module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [(_vm.displayFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "font-w300 align-center push-10"
  }, [_vm._v(_vm._s(_vm.actualNews.title[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.actualNews.sections), function(section, index) {
    return _c('div', [_c('h3', {
      staticClass: "font-w300 align-center push-10"
    }, [_vm._v(_vm._s(section.subTitle[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((section.lines), function(line, index) {
      return _c('div', [_c('p', {
        staticClass: "font-w300 align-center push-10"
      }, [_vm._v(_vm._s(line[_vm.actualLanguage]))])])
    }), _vm._v(" "), (section.picture.length > 2) ? _c('div', {
      staticClass: "col-xs-12 col-md-12 align-center"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('p', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "width": "125px",
        "src": _vm._f("s3Image")(("news/" + (section.picture)))
      }
    })])])]) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 align-center"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "for": "example-checkbox1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dontShowAgainFlag),
      expression: "dontShowAgainFlag"
    }],
    staticClass: "larger",
    attrs: {
      "type": "checkbox",
      "id": "example-checkbox1",
      "name": "example-checkbox1",
      "value": "option1"
    },
    domProps: {
      "checked": Array.isArray(_vm.dontShowAgainFlag) ? _vm._i(_vm.dontShowAgainFlag, "option1") > -1 : (_vm.dontShowAgainFlag)
    },
    on: {
      "click": _vm.toggleDontShowAgain,
      "change": function($event) {
        var $$a = _vm.dontShowAgainFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "option1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.dontShowAgainFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.dontShowAgainFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.dontShowAgainFlag = $$c
        }
      }
    }
  }), _vm._v(_vm._s(_vm.labelDontShowAgain[_vm.actualLanguage]) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 align-center push"
  }, [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.closeModalWindow
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labelButtonClose[_vm.actualLanguage]))])])])], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21833862","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/DashboardNews.vue
// module id = 1509
// module chunks = 4